import { render, staticRenderFns } from "./RedirectList.vue?vue&type=template&id=318156bc"
import script from "./RedirectList.vue?vue&type=script&lang=js"
export * from "./RedirectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports